<template>
  <div class="searchResultDistanceContainer">
    <a target="_blank" :href="url" :aria-label="ariaLabel"
      ><i class="c-coral fas fa-map-marker-alt mr-3"></i
    ></a>
    <span>{{ formattedDistance }}</span>
  </div>
</template>

<script>
import { lowerCase } from '@/utilities/filters'

export default {
  props: { ariaLabel: String, distance: String, url: String },
  computed: {
    formattedDistance() {
      return `${String(this.distance)} ${lowerCase(this.$t('org.milesAway'))}`
    },
  },
}
</script>
